import React from "react";
import { EmptyArea, Description } from "./Styled";
import { Empty, Button } from "antd";

type ItemManager<T> = {
  Menu: React.ReactNode;
  Content: React.ReactNode;
  selectedItem: T | undefined | null;
  emptyDescription?: string | undefined;
  EmptyImage?: React.ReactNode | undefined;
  onClick?: () => void;
};

const ItemManager = <T extends any>(): React.FunctionComponent<
  ItemManager<T>
> => ({ Menu, Content, selectedItem, EmptyImage, emptyDescription, onClick }) => {
  const renderEmptyData = () => {
    return (
      <EmptyArea>
        <Empty
          image={EmptyImage ? EmptyImage : Empty.PRESENTED_IMAGE_SIMPLE}
          imageStyle={{
            height: 60
          }}
          description={<Description>{emptyDescription ? emptyDescription : ""}</Description>}
        >
          {onClick ? <Button type="primary">Create Now</Button> : null}
        </Empty>
      </EmptyArea>
    );
  };

  const renderContent = () => {
    if (selectedItem !== null) {
      return Content;
    } else {
      return renderEmptyData();
    }
  };

  return (
    <>
      {Menu}
      {renderContent()}
    </>
  );
};

ItemManager.defaultProps = {
  selectedItem: null
};

export default ItemManager;
